/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';
import { PatientDemographicsMaster } from '../../../interfaces/masters/patientDemographicsMaster';

@Injectable()
export class PatientDemographicsMasterApi {

  private readonly apiController: string = 'patientDemographicsMaster/';

  constructor(private api: HttpService) { }


  list(url: string,options?: any): Observable<any[]> {
    const header = new HttpHeaders({ "Accept": "application/vnd.ezovion.hateoas+json" });

    return this.api.get(this.apiController + url, { headers: { "Accept": "application/vnd.ezovion.hateoas+json", 'Content-Type': "application/json" } });
  }



  add(url: string, data: PatientDemographicsMaster): Observable<PatientDemographicsMaster> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept', 'application/vnd.ezovion.hateoas+json');
    return this.api.directPost(url, data, header);
  }


  update(url: string, data: PatientDemographicsMaster): Observable<any> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept', 'application/vnd.ezovion.hateoas+json');
    return this.api.directPut(url, data, { headers: { "Accept": "application/vnd.ezovion.hateoas+json", 'Content-Type': "application/json" } });
  }


}
